<script lang="ts">
  import { assets } from '$app/paths';
  import { Block } from '@reuters-graphics/graphics-components';
  let { block } = $props();
</script>

<Block class="my-10">
  <div class="flex pack">
    <div>
      <img
        src="{assets}/photos/post-18/iraq.jpg"
        alt=""
        aria-hidden="true"
        width="1200"
        height="675"
      />
    </div>
    <div class="row">
      <div>
        <img src="{assets}/photos/post-18/fire.jpg" alt="" aria-hidden="true" />
      </div>
      <div>
        <img
          src="{assets}/photos/post-18/oman-smoke.jpg"
          alt=""
          aria-hidden="true"
        />
      </div>
    </div>
  </div>
  {#if block.captions}
    <div class="photopack-captions-container">
      {#each block.captions as caption}
        <div class="caption">
          <p>{caption.caption}</p>
        </div>
      {/each}
    </div>
  {/if}
</Block>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  .photopack-captions-container .caption p {
    @include mixins.body-caption;
  }

  .flex {
    display: flex;
    gap: 4px;
    flex-direction: column;
    .row {
      display: flex;
      gap: 4px;
      > div {
        flex: 1;
        aspect-ratio: 2 / 3;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
    }
    img {
      width: 100%;
      height: auto;
      margin: 0;
    }
  }
</style>
